export const LINK_TYPE = {
  Primary: 'Primary',
  Secondary: 'Secondary',
  Dark: 'Dark',
  NoUnderline: 'NoUnderline',
  NoStyle: 'NoStyle',
  InheritColor: 'InheritColor',
} as const;

export type LinkType = typeof LINK_TYPE[keyof typeof LINK_TYPE]
